module.exports = __webpack_public_path__ + "img/nav_icon_suggestion.debb97a8.svg";